import { render, staticRenderFns } from "./EmailTemplateBodyEditor.vue?vue&type=template&id=137bfbc2&scoped=true"
import script from "./EmailTemplateBodyEditor.vue?vue&type=script&lang=js"
export * from "./EmailTemplateBodyEditor.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplateBodyEditor.vue?vue&type=style&index=0&id=137bfbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137bfbc2",
  null
  
)

export default component.exports